declare namespace $ {

	type $mol_text__text_shm_hitalama_map_widget_float_tokens_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_tokens_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_tokens extends $shm_hitalama_map_widget_float {
		Tokens_label( ): $mol_text
		token( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_tokens['Token_switch'] >['current'] >
		Token_switch( ): $shm_hitalama_vk_token_switch
		Tokens( ): $mol_view
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tokens.view.tree.d.ts.map